/* eslint-disable import/no-anonymous-default-export */
import auth from './auth';
import event from './event';

export default {
  auth,
  event,
};
